export const CATALOG_SECTION_ENDPOINT = window.location.pathname.split('/')[2]